import {useDispatch, useSelector} from "react-redux";
import {useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {setHeader} from "../../../redux/actions/layout/interaction/action";
import moment from "moment/moment";
import {KeyConstant} from "../../can/weighing-slip/constant/keyConstant";
import {Button, Card, Checkbox, Col, List, message, Modal, Pagination, Row, Select, Space, Tag} from "antd";
import {mapTag} from "../../can/weighing-slip/common/mapTag";
import {mapTitleDate} from "../../can/weighing-slip/common/mapTitleDate";
import {ArrowDownOutlined, ArrowUpOutlined, DownOutlined} from "@ant-design/icons";
import {RiFilter3Fill} from "react-icons/ri";
import Report from "../../can/weighing-slip/report/report";
import {getReportCompare, getReportNow} from "../../../api/report";
import {mapMoneyMobile} from "../../can/weighing-slip/common/mapMoneyMobile";
import {deleteWeightSlips, getAllWeightSlipsUi} from "../../../api/weightSlip";
import {mapMoneyListMobile} from "../../can/weighing-slip/common/mapMoneyListMobile";
import {DG_Format_Money} from "../../../format/money";
import styled from "styled-components";
import CalendarModalParentFilter from "./model/calendarModalParentFilter";
import SockJS from "sockjs-client";
import {BASE_PATH} from "../../../custom/axios/config/Url";
import Stomp from "stompjs";
import {t} from "i18next";
import {getMe} from "../../../api/system/admin/user-account";
import CalendarModalParentDate from "./model/calendarModalParentDate";

const styleColor = {
    color: "#98A2B3",
    fontWeight: 400
}

const styleColor1 = {
    color: "#344054",
    fontWeight: 600,
    fontsize: 18
}

const styleColor2 = {
    fontWeight: 400,
    fontsize: 16,
}

const styleColor3 = {
    color: "#101828",
    fontWeight: 600,
}

const stylePercentIncrease = {
    color: "#12B76A",
    marginLeft: 10,
    fontWeight: 600,
}
const stylePercentReduction = {
    color: "#F04438",
    marginLeft: 10,
    fontWeight: 600,
}

const styleCol = {
    // paddingTop : 8,
    borderRight: "1px solid #EAECF0",
    borderBottom: "1px solid #EAECF0",
}

const styleRowPadding = {
    textAlign: "center",
    cursor: "pointer",
}

const styleRowPaddingBG = {
    textAlign: "center",
    backgroundColor: "#F2F4F7",
    cursor: "pointer",
    color: "#0065D9"
}

const styleBorderBottom = {
    borderBottom: "1px solid #EAECF0",
    padding: "8px 0"
}

const StyledList = styled(List)`
  .ant-spin-container {
    //height: ${(props) => props?.height + "px"};
    //overflow-y: auto;
    //height: 1225px;
  }

  .ant-list-item {
    display: list-item !important;
    padding-right: 12px !important;
  }

  :where(.css-dev-only-do-not-override-1op8qta).ant-list{
    height: ${(props) => props?.height + "px"} !important;
  }
`;
var stompClient = null
const IndexMobile = () => {

    const height= window.innerHeight;
    const headerMobile = document.getElementById('header-mobile')?.clientHeight
    const filterMobile = document.getElementById('filter-mobile')?.clientHeight
    const listItemMobile = document.getElementById('list-item-do-goo-height')?.clientHeight

    const [searchParams] = useSearchParams()
    const dispatch = useDispatch()
    const {code} = useParams()
    const {weighingStation} = useSelector(state => state.permissionAccountActionReducer)
    const [calendar, setCalendar] = useState({
        startDate: moment().subtract(28, "days").toDate(),
        endDate: moment().subtract(1, "days").toDate(),
        compare: false,
        compareType: "previousPeriod",
        type: KeyConstant.THIRTY_DAYS_AGO
    })
    const [visible, setVisible] = useState(false)
    const [visibleFilter, setVisibleFilter] = useState(false)
    const [reloadReport, setReloadReport] = useState(false)
    const [dataCompare, setDataCompare] = useState()
    const [type, setType] = useState("bill")
    const [dataSource, setDatasource] = useState()
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [total, setTotal] = useState(0)
    const [check, setCheck] = useState(true);
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reloadData1, setReloadData] = useState(false);
    const me = getMe();
    const [refresh, setRefresh] = useState()
    const [color, setColor] = useState(false)
    const [dataNow, setDataNow] = useState()

    useEffect(() => {
        const socket1 = new SockJS(`${BASE_PATH}/public/dogoo/ws-message`);
        stompClient = Stomp.over(socket1);
        stompClient.connect({}, function (frame) {
            stompClient.subscribe("/public/dogoo/messages", function (greeting) {
                let data = JSON.parse(greeting.body)
                if (data.databaseKey === code) {
                    setRefresh(data.date)
                }
            });
        });
    }, [code])

    const onCheckAllChange = (e) => {
        setIndeterminate(false);
        setSelectedRowKeys(dataSource ? dataSource?.map(item => item.key) : [])
        setCheckAll(e.target.checked)
        if (e.target.checked) {
            setSelectedRowKeys(dataSource?.map(item => item.key))
        } else {
            setSelectedRowKeys([])
        }
    }

    useEffect(() => {
        let ws = weighingStation.filter(item => item.weighingStationCode === code)
        dispatch(setHeader(ws[0]?.weighingStationName))
    }, [weighingStation, code , dispatch])

    useEffect(() => {

        let dateStart = searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
            moment().subtract(28, "days").toDate()
        let dateEnd = searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
            moment().subtract(1, "days").toDate()

        let startDate = moment(dateStart);
        let endDate = moment(dateEnd);
        let startDateAxios = moment(dateStart);
        let endDateAxios = moment(dateEnd);
        let startDateCompare = null
        let endDateCompare = null

        let compare = searchParams.get("compare") ? searchParams.get("compare") : false
        let compareType = searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod"
        let type = searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO

        if (compare) {
            let dateDiff = endDate.diff(startDate, 'days') + 1
            if (compareType === "previousPeriod") {
                switch (type) {
                    case KeyConstant.TODAY:
                    case KeyConstant.YESTERDAY:
                        startDateCompare = startDate.subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.THIS_WEEK:
                    case KeyConstant.LAST_WEEK:
                        startDateCompare = startDate.subtract(1, "weeks").startOf("week").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = startDate.subtract(1, "weeks").endOf("week").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.THIS_MONTH:
                    case KeyConstant.LAST_MONTH:
                        startDateCompare = moment(startDate).subtract(1, "months").startOf("month").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = moment(startDate).subtract(1, "months").endOf("month").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.SEVEN_DAYS_AGO:
                        startDateCompare = startDate.subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.THIRTY_DAYS_AGO:
                        startDateCompare = startDate.subtract(30, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(30, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.NINETY_DAYS_AGO:
                        startDateCompare = startDate.subtract(90, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(90, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    default :
                        startDateCompare = startDate.subtract(dateDiff, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(dateDiff, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                }
            } else if (calendar.compareType === "periodLastYear") {
                startDateCompare = startDate.subtract(1, "years").format("YYYY-MM-DDTHH:mm:ss")
                endDateCompare = endDate.subtract(1, "years").format("YYYY-MM-DDTHH:mm:ss")
            }
        }

        getReportCompare(code, startDateAxios.format('YYYY-MM-DDTHH:mm:ss'),
            endDateAxios.format('YYYY-MM-DDTHH:mm:ss'), startDateCompare, endDateCompare).then(r => {
            setDataCompare(r)
        })
            .catch(() => {
            })
    }, [calendar, refresh, reloadData1, code, searchParams])

    const mapDatasource = (data) => {
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                key: item.weightSlipId,
                ...item,
                ngayCan: <>
                    <span> {moment(item.ngayCan).format("DD/MM/YYYY")} </span> -
                    <span> {moment(item.gioKTai).parseZone().format("HH:mm")} </span>
                </>,
                donGia: DG_Format_Money(Number(item.donGia)),
                hang: DG_Format_Money(Number(item.hang)),
            };
        });
    }

    useEffect(() => {
        getReportNow(code).then(r => {
            setDataNow(r)
        })
            .catch(() => {
            })
        setColor(searchParams.get('soXe') || searchParams.get('tenHang') || searchParams.get('khachHang'))
        getAllWeightSlipsUi(code, page - 1, pageSize, searchParams.getAll('soXe'),
            searchParams.getAll('tenHang'), searchParams.getAll('khachHang'),
            searchParams.get("startDate") ? moment(searchParams.get("startDate")).format('YYYY-MM-DDTHH:mm:ss') :
                moment().subtract(28, "days").format('YYYY-MM-DDTHH:mm:ss'),
            searchParams.get("endDate") ? moment(searchParams.get("endDate")).format('YYYY-MM-DDTHH:mm:ss') :
                moment().subtract(1, "days").format('YYYY-MM-DDTHH:mm:ss'),
            searchParams.get('search')).then(r => {
            setDatasource(mapDatasource(r.content))
            setTotal(r.totalElements)
            setCheck(r.content.length > 0 ? r.content[0].permission : true)
        })
            .catch(() => {
            })
    }, [page, pageSize, calendar,
        searchParams, refresh, reloadData1, code])

    const handleOk = () => {
        let s = selectedRowKeys.join("&id=")
        deleteWeightSlips("?id=" + s, me.key, code).then(r => {
            message.info("Xóa được đưa vào hàng đợi hệ thống đồng bộ")
            setReloadData(!reloadData1)
            setIsModalVisible(false)
        })
            .catch(() => {
            })
    }
    return (
        <>
            <Row className={"py-3"} id={"filter-mobile"}>
                <Col span={20} className={"flex"}>
                    <Tag color='#E6F7FF' style={{color: "#0065D9", borderRadius: 8, height: 22, marginLeft: 12}}>
                        {mapTag(calendar?.type, calendar?.startDate, calendar?.endDate)}
                    </Tag>
                    <div className={" cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden"}
                         onClick={() => setVisible(true)}>
                        {mapTitleDate(calendar?.type, calendar?.startDate, calendar?.endDate)}
                        <DownOutlined style={{marginLeft: 11, height: 5, width: 10}}/>
                    </div>
                </Col>
                <Col span={4}>
                    <Space align={"center"} className={"cursor-pointer customer_space"}>
                        <span style={{color: "#344054"}}>
                            Lọc
                        </span>
                        <RiFilter3Fill style={{fontSize: 15, color: color ? "#FF3838" : "black"}}
                                       onClick={() => setVisibleFilter(true)}/>
                    </Space>
                </Col>
            </Row>

            <div className={"overflow-y-auto overflow-x-hidden h-full bg-white customer_scroll"}>
                <div className={"bg-white"} id={"chart-mobile"} style={{borderTop: "1px solid #EAECF0"}}>
                    <Row className={"p-2.5"} gutter={24}>
                        <Col span={24} className={"mb-2"}>
                            <Card
                                className={"h-full"}
                                bodyStyle={{
                                    padding: 10,
                                    borderRadius: 1000,
                                }}
                            >
                                <Row>
                                    <Col span={8} style={styleCol}>
                                        <Row style={type === "bill" ? styleRowPaddingBG : styleRowPadding}
                                             onClick={() => setType("bill")}>
                                            <Col span={24} className={"pt-2"}>
                                                <span style={styleColor2} className={"text-base"}> Phiếu xuất </span>
                                            </Col>
                                            <Col span={24} className={"mb-2 flex flex-col "}>
                                                <span
                                                    style={{...styleColor3, fontSize: 20}}> {dataCompare?.bill} </span>
                                                {
                                                    dataCompare && dataCompare?.billPercent !== 0 &&
                                                    <>
                                                        {
                                                            dataCompare?.billPercent > 0 ?
                                                                <span style={stylePercentIncrease}>
                                                            <ArrowUpOutlined/> {dataCompare?.billPercent}%
                                                        </span> :
                                                                <span style={stylePercentReduction}>
                                                            <ArrowDownOutlined/> {Math.abs(dataCompare?.billPercent)}%
                                                        </span>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={8} style={styleCol}>
                                        <Row style={type === "netWeight" ? styleRowPaddingBG : styleRowPadding}
                                             onClick={() => setType("netWeight")}>
                                            <Col span={24} className={"pt-2"}>
                                                <span style={styleColor2} className={"text-base"}> Khối lượng  </span>
                                            </Col>
                                            <Col span={24} style={styleColor1}
                                                 className={"mb-2 flex flex-col "}>
                                            <span style={{
                                                ...styleColor3,
                                                fontSize: 20
                                            }}> {DG_Format_Money(dataCompare?.netWeight / 1000)}
                                                <span style={{
                                                    ...styleColor,
                                                    fontSize: 14
                                                }}> tấn </span> </span>
                                                {
                                                    dataCompare && dataCompare?.netWeightPercent !== 0 &&
                                                    <>
                                                        {
                                                            dataCompare?.netWeightPercent > 0 ?
                                                                <span style={stylePercentIncrease}>
                                                            <ArrowUpOutlined/> {dataCompare?.netWeightPercent}%
                                                        </span> :
                                                                <span style={stylePercentReduction}>
                                                            <ArrowDownOutlined/> {Math.abs(dataCompare?.netWeightPercent)}%
                                                        </span>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={8} style={{borderBottom: "1px solid #EAECF0"}}>
                                        <Row style={type === "revenue" ? styleRowPaddingBG : styleRowPadding}
                                             onClick={() => setType("revenue")}>
                                            <Col span={24} className={"pt-2"}>
                                                <span style={styleColor2} className={"text-base"}> Doanh thu  </span>
                                            </Col>
                                            <Col span={24} style={styleColor1}
                                                 className={"mb-2 flex flex-col"}>
                                                {
                                                    mapMoneyMobile(dataCompare?.revenue)
                                                }
                                                {
                                                    dataCompare && dataCompare?.revenuePercent !== 0 &&
                                                    <>
                                                        {
                                                            dataCompare?.revenuePercent > 0 ?
                                                                <span style={stylePercentIncrease}>
                                                            <ArrowUpOutlined/> {dataCompare?.revenuePercent}%
                                                        </span> :
                                                                <span style={stylePercentReduction}>
                                                            <ArrowDownOutlined/> {Math.abs(dataCompare?.revenuePercent)}%
                                                        </span>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className={"flex justify-center"}>
                                        <Report calendar={calendar} code={code} type={type} reloadReport={reloadReport}
                                                refresh={refresh}/>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col span={24}>
                            <Card
                                className={"custom_home_card h-full"}
                                headStyle={{
                                    padding: 10
                                }}
                                bodyStyle={{
                                    padding: "12px 24px"
                                }}
                            >
                                <Row>
                                    <Col span={24} style={styleColor}>
                                        Hôm nay
                                    </Col>
                                </Row>
                                <Row style={styleBorderBottom}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Phiếu xuất </span>
                                        <span style={styleColor} className={"ml-1"}> (phiếu) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {dataNow?.bill}
                                    </Col>
                                </Row>
                                <Row style={styleBorderBottom}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Khối lượng  </span> <span
                                        style={styleColor} className={"ml-1"}> (tấn) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {dataNow?.netWeight / 1000 || 0}
                                    </Col>
                                </Row>
                                <Row style={styleBorderBottom}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Doanh thu  </span> <span
                                        style={styleColor} className={"ml-1"}> (VNĐ) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {DG_Format_Money(dataNow?.revenue)}
                                    </Col>
                                </Row>
                                <Row style={{paddingTop: 8}}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Khách hàng  </span> <span
                                        style={styleColor} className={"ml-1"}> (số lượng) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {dataNow?.customer}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <div className={"bg-white px-3 custom-list-item "}>
                    {
                        dataSource && <StyledList
                            // height={height - headerMobile - filterMobile - 100}
                            height={listItemMobile ? listItemMobile + 50 : 1410}
                            size="small"
                            header={<Row style={{height: 32}} className={"items-center"}>
                                <Col span={20}>
                                    {
                                        check && dataSource &&
                                        <Checkbox indeterminate={indeterminate}
                                                  onChange={onCheckAllChange}
                                                  checked={checkAll}/>
                                    }
                                </Col>
                                <Col span={2}>
                                    {
                                        selectedRowKeys.length > 0 && check &&
                                        <Button type="primary" style={{color: "white"}}
                                                onClick={() => setIsModalVisible(true)}>
                                            Xóa
                                        </Button>
                                    }
                                </Col>
                            </Row>}
                            footer={<Row>
                                <Col span={24} className={"flex justify-end items-center"}>
                                    {
                                        total > 0 && <Pagination simple
                                                                 pageSize={pageSize}
                                                                 defaultCurrent={page}
                                                                 total={total}
                                                                 className={"flex text-center items-center"}
                                                                 showQuickJumper
                                                                 onChange={(page) => setPage(page)}/>
                                    }
                                    {/*{
                                        total > 0 &&
                                        <div className={"customer_select_page"}>
                                            <Select
                                                defaultValue={pageSize}
                                                options={[
                                                    {value: 20, label: 20},
                                                    {value: 30, label: 30},
                                                    {value: 50, label: 50},
                                                    {value: 100, label: 100},
                                                ]}
                                                size={"small"}
                                                onChange={(value) => setPageSize(value)}
                                            />
                                        </div>
                                    }*/}
                                </Col>
                            </Row>}
                            bordered
                            dataSource={dataSource}
                            renderItem={(item) => (
                                <List.Item>
                                    <Row className={"items-center"}>
                                        <Col span={2}>
                                            <Checkbox onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedRowKeys(selectedRowKeys.concat(item.key))
                                                    setIndeterminate(true)
                                                } else {
                                                    let selectKey = selectedRowKeys.filter(key => key !== item.key)
                                                    setSelectedRowKeys(selectKey)
                                                    setIndeterminate(selectKey.length > 0)
                                                }
                                            }} checked={selectedRowKeys.includes(item.key)}/>
                                        </Col>
                                        <Col span={22}>
                                            <Row>
                                                <Col span={14}>
                                                    <span className={"font-semibold"}>{item.khachHang}</span>
                                                </Col>
                                                <Col span={10}>
                                                    <span
                                                        className={"float-right"}>{mapMoneyListMobile(item.thanhTien)}</span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={11}>
                                                    <span className={"text-xs"}>{item.ngayCan}</span>
                                                </Col>
                                                <Col span={13}>
                                                <span className={"float-right truncate "} style={{
                                                    maxWidth: "95%"
                                                }}>{item.soXe}|{item.tenHang}|{item.hang}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </List.Item>
                            )}
                            className={'list-item-do-goo'}
                            id={'list-item-do-goo-height'}
                        />
                    }
                </div>
            </div>

            <CalendarModalParentDate visible={visible}
                                     onCancel={() => setVisible(false)}
                                     onData={(value) => {
                                         setCalendar(value)
                                         setReloadReport(!reloadReport)
                                     }} />

            <CalendarModalParentFilter visible={visibleFilter}
                                       onCancel={() => setVisibleFilter(false)}
                                       code={code}/>

            <Modal
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                okText={t("common.btn.delete")}
                cancelText={<strong style={{color: "rgba(236,41,41,0.9)"}}>{t("common.btn.cancel")}</strong>}
                destroyOnClose={true}
                onOk={handleOk}
            >
                <p>{t("common.message.deleteAsk")}</p>
            </Modal>
        </>
    )
}

export default IndexMobile
